<template>
	<pre><ConsoleEventArg renderAs='ArgArray' :value="value.data.arr">{{value.data.ctorName}}</ConsoleEventArg></pre>
</template>

<script>
export default {
	name: 'ArgTypedArray',
	props: {value: Object},
}
</script>
